import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Timeline } from './components/Timeline';
import { VideoSection } from './components/VideoSection';
import { Metaphors } from './components/Metaphors';
import { BehindTheScenes } from './components/BehindTheScenes';
import { PromptSection } from './components/PromptSection';
import { TranscriptSection } from './components/TranscriptSection';
import { Footer } from './components/Footer';

export default function App() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <Timeline />
        <VideoSection />
        <Metaphors />
        <BehindTheScenes />
        <PromptSection />
        <TranscriptSection />
        <Footer />
      </main>
    </div>
  );
}


